/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.DeleteDocument";
        class DocActionDeleteDocument extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._modalSession = null;
                this._docDeleteConfirmed = (request) => {
                    this._log.info("DocActionDeleteDocument._docDeleteConfirmed()");
                    let modalSession = 'delete-doc-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                        this._modalSession = modalSession;
                    }
                    this._core.Loader.genericServiceCall(`/Documents.svc/rest/DeleteDocument/${request.DocHandle}`, this._docDeleted.bind(this, request), this._errorCallback, this._failCallback);
                };
                this._docDeleted = (request, response) => {
                    this._log.info("DocActionDeleteDocument._docDeleted()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(null, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DELETED);
                    navEvent.ActivationID = request.DocHandle;
                    navEvent.Layout = this._core.Navigation.Details.getActiveLayoutName();
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._failCallback = (json) => {
                    this._log.info("DocActionDeleteDocument._failCallback()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let response = json;
                    console.warn(response.Connection.Message);
                    this._core.Helper.presentWarningModal(response.Connection.Message);
                };
                this._errorCallback = (url, status, message) => {
                    this._log.info("DocActionDeleteDocument._errorCallback()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    console.warn(message);
                    this._core.Helper.presentWarningModal(message);
                };
                this._doctypesLoaded = () => {
                    this._log.info("DocActionDeleteDocument._doctypesLoaded()");
                    // do nothing here, callback is used to force loading of download document types if needed
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionDeleteDocument::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_DELETE_DOC");
                this._core.OBHelper.LoadDownloadDocumentTypes(this._doctypesLoaded);
            }
            actionAllowed(request) {
                this._log.info("DocActionDeleteDocument.actionAllowed()");
                if (request.hasOwnProperty('DocumentType') && request.DocumentType) {
                    if (request.DocumentType.Name in this._core.OBHelper.DownloadDocumentTypeMap) {
                        return this._core.OBHelper.DownloadDocumentTypeMap[request.DocumentType.Name].Privileges.DocumentDeletion;
                    }
                }
                return false;
            }
            execute(request) {
                this._log.info("DocActionDeleteDocument.execute()");
                this._core.Helper.presentWarningContinueModal('STR_WPT_CONFIRM_DELETE_DOC', this._docDeleteConfirmed.bind(this, request), 'STR_WPT_CONTINUE_HEADING');
            }
        }
        DocActions.DocActionDeleteDocument = DocActionDeleteDocument;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
